/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_CommentInputs */

const en_markers_export_comment = /** @type {(inputs: Markers_Export_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment`)
};

const fr_markers_export_comment = /** @type {(inputs: Markers_Export_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commentaire`)
};

const de_markers_export_comment = /** @type {(inputs: Markers_Export_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentar`)
};

const it_markers_export_comment = /** @type {(inputs: Markers_Export_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commento`)
};

const ru_markers_export_comment = /** @type {(inputs: Markers_Export_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Комментарий`)
};

const es_markers_export_comment = /** @type {(inputs: Markers_Export_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentario`)
};

const zh_cn2_markers_export_comment = /** @type {(inputs: Markers_Export_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评论`)
};

const ja_markers_export_comment = /** @type {(inputs: Markers_Export_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメント`)
};

const hi_markers_export_comment = /** @type {(inputs: Markers_Export_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टिप्पणी`)
};

const pt_pt2_markers_export_comment = /** @type {(inputs: Markers_Export_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentário`)
};

/**
* | output |
* | --- |
* | "Comment" |
*
* @param {Markers_Export_CommentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_comment = /** @type {((inputs?: Markers_Export_CommentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_CommentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_export_comment(inputs)
	if (locale === "de") return de_markers_export_comment(inputs)
	if (locale === "it") return it_markers_export_comment(inputs)
	if (locale === "ru") return ru_markers_export_comment(inputs)
	if (locale === "es") return es_markers_export_comment(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_export_comment(inputs)
	if (locale === "ja") return ja_markers_export_comment(inputs)
	if (locale === "hi") return hi_markers_export_comment(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_export_comment(inputs)
	return en_markers_export_comment(inputs)
});